module.exports = __webpack_public_path__ + "img/2010 radtour ehrenabteilung 013.59ca696f.jpg";